import { DateFormat } from "src/com/sixdee/crbtportal/ui/toolkit/dateformat/dateformat";
import { ToneStatus } from "src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonestatus";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { ChildListTonesDto, ChildListTonesDtoImpl } from "../childlisttonesdto";
import { GroupDtoImpl } from "../groupdto";
import { MemberDetailsDtoImpl, MemberDetailsDto } from "../memberdetailsdto";


export class CurrentlyPlayingListTonesBuilder {
    constructor(private listTones: any, private context: BaseContext) {

        /* if(listTones.listToneApk.toneDetails === undefined)
        {
            throw new NoDataException("Get Banner data doesnt exists");
        } */
    }

    buildAll(): ChildListTonesDto[] {
        return this.parseListTonesResponse();
    }

    private parseListTonesResponse(): ChildListTonesDto[] {
        let listOfListTones: ChildListTonesDto[] = [];
        let childListTonesDto: ChildListTonesDtoImpl;
        let groupDto: GroupDtoImpl;
        let timeType:string[];


        this.listTones.listToneApk.forEach((listToneApkItem: any , index:any ) => {
            console.log("--list tone callers"+listToneApkItem.toneDetails);

            if (listToneApkItem.toneDetails !== undefined) {
                
                listToneApkItem.toneDetails.forEach((toneItem: any) => 
                {
                    console.log("-----shuffle in listtonebuilder "+toneItem);
                    childListTonesDto = new ChildListTonesDtoImpl();
                    childListTonesDto.setId(toneItem.toneId);
                    childListTonesDto.setToneName(toneItem.toneName);
                    childListTonesDto.setToneUrl(toneItem.toneIdStreamingUrl);
                    childListTonesDto.setImgPath(toneItem.toneIdpreviewImageUrl);
                    childListTonesDto.setAlbumName(toneItem.albumName);
                    childListTonesDto.setArtistName(toneItem.artistName);
                    childListTonesDto.setPrice(toneItem.price);
                    childListTonesDto.setStatus(this.getStatus(toneItem.status));
                    childListTonesDto.setCreatedDate(toneItem.createdDate);
                    // childListTonesDto.setIsShuffle(toneItem.isShuffle);
                 
                    childListTonesDto.setCallerStatus(toneItem.status);
                    // childListTonesDto.setEndTime(toneItem.endTime);
                    // childListTonesDto.setStartTime(toneItem.startTime);
                    // childListTonesDto.setEndDayMonthly(toneItem.endDayMonthly);
                    // childListTonesDto.setEndTimeMonthly(toneItem.endTimeMonthly);
                    // childListTonesDto.setStartDayMonthly(toneItem.startDayMonthly);
                    // childListTonesDto.setStartTimeMonthly(toneItem.startTimeMonthly);
                    // childListTonesDto.setEndTimeWeekly(toneItem.endTimeWeekly);
                    // childListTonesDto.setStartTimeWeekly(toneItem.startTimeWeekly);
                    childListTonesDto.setWeeklyDays(toneItem.weeklyDays);
                    // childListTonesDto.setCustomiseEndDate(toneItem.customiseEndDate);
                    // childListTonesDto.setCustomiseEndTime(toneItem.customiseEndTime);
                    // childListTonesDto.setCustomiseStartDate(toneItem.customiseStartDate);
                    // childListTonesDto.setCustomiseStartTime(toneItem.customiseStartTime);
                    // childListTonesDto.setYearlyEndDay(toneItem.yearlyEndDay);
                    // childListTonesDto.setYearlyEndMonth(toneItem.yearlyEndMonth);
                    // childListTonesDto.setYearlyEndTime(toneItem.yearlyEndTime);
                    // childListTonesDto.setYearlyStartDay(toneItem.yearlyStartDay);
                    // childListTonesDto.setYearlyStartMonth(toneItem.yearlyStartMonth);
                    // childListTonesDto.setYearlyStartTime(toneItem.yearlyStartTime);
                    childListTonesDto.setServiceName(listToneApkItem.serviceName);
                    childListTonesDto.setExpirydate(DateFormat.formatExpiryDate(listToneApkItem.expiryDate, this.context));

                        //start & end time
                    if(toneItem.endTime !== undefined && toneItem.startTime !== undefined)
                    {
                        childListTonesDto.setEndTime(toneItem.endTime);
                        childListTonesDto.setStartTime(toneItem.startTime);


                    }
                    else
                    {
                        childListTonesDto.setEndTime(this.context.getResources().getString(Strings.zero));
                        childListTonesDto.setStartTime(this.context.getResources().getString(Strings.zero));

                    }
                    
                    // Monthly 
                    if(toneItem.endDayMonthly !== undefined && toneItem.startDayMonthly !== undefined)
                    {
                        childListTonesDto.setEndDayMonthly(toneItem.endDayMonthly);
                        childListTonesDto.setStartDayMonthly(toneItem.startDayMonthly);


                    }
                    else
                    {
                        childListTonesDto.setEndDayMonthly(this.context.getResources().getString(Strings.zero));
                        childListTonesDto.setStartDayMonthly(this.context.getResources().getString(Strings.zero));

                    }
                    // end time 
                    if(toneItem.endTimeMonthly !== undefined && toneItem.startTimeMonthly !== undefined)
                    {
                        childListTonesDto.setEndTimeMonthly(toneItem.endTimeMonthly);
                        childListTonesDto.setStartTimeMonthly(toneItem.startTimeMonthly);


                    }else{
                        childListTonesDto.setEndTimeMonthly(this.context.getResources().getString(Strings.zero));
                        childListTonesDto.setStartTimeMonthly(this.context.getResources().getString(Strings.zero));

                    }

                    
                    //end time weekly

                    if(toneItem.endTimeWeekly !== undefined && toneItem.startTimeWeekly !== undefined)
                    {
                        childListTonesDto.setEndTimeWeekly(toneItem.endTimeWeekly);
                        childListTonesDto.setStartTimeWeekly(toneItem.startTimeWeekly);

                    }
                    else{
                        childListTonesDto.setEndTimeWeekly(this.context.getResources().getString(Strings.zero));
                        childListTonesDto.setStartTimeWeekly(this.context.getResources().getString(Strings.zero));

                    }

                   // custome date
                   if(toneItem.customiseEndDate !== undefined && toneItem.customiseStartDate !== undefined)
                   {
                       childListTonesDto.setCustomiseEndDate(toneItem.customiseEndDate);
                       childListTonesDto.setCustomiseStartDate(toneItem.customiseStartDate);

                   }
                   else{
                       childListTonesDto.setCustomiseEndDate(this.context.getResources().getString(Strings.zero));
                       childListTonesDto.setCustomiseStartDate(this.context.getResources().getString(Strings.zero));

                   }

                   //custome time
                   if(toneItem.customiseEndTime !== undefined && toneItem.customiseStartTime !== undefined)
                   {
                       childListTonesDto.setCustomiseEndTime(toneItem.customiseEndTime);
                       childListTonesDto.setCustomiseStartTime(toneItem.customiseStartTime);

                   }
                   else{
                       childListTonesDto.setCustomiseEndTime(this.context.getResources().getString(Strings.zero));
                       childListTonesDto.setCustomiseStartTime(this.context.getResources().getString(Strings.zero));

                   }
                   //yearly 
                   if(toneItem.yearlyEndDay !== undefined && toneItem.yearlyStartDay !== undefined)
                   {
                       childListTonesDto.setYearlyEndDay(toneItem.yearlyEndDay);
                       childListTonesDto.setYearlyStartDay(toneItem.yearlyStartDay);

                   }
                   else{
                       childListTonesDto.setYearlyEndDay(this.context.getResources().getString(Strings.zero));
                       childListTonesDto.setYearlyStartDay(this.context.getResources().getString(Strings.zero));

                   }

                   //yearlyEndMonth
                   if(toneItem.yearlyEndMonth !== undefined && toneItem.yearlyStartMonth !== undefined)
                   {
                       childListTonesDto.setYearlyEndMonth(toneItem.yearlyEndMonth);
                       childListTonesDto.setYearlyStartMonth(toneItem.yearlyStartMonth);

                   }
                   else{
                       childListTonesDto.setYearlyEndMonth(this.context.getResources().getString(Strings.zero));
                       childListTonesDto.setYearlyStartMonth(this.context.getResources().getString(Strings.zero));

                   }
                   //yearlyEndTime
                   if(toneItem.yearlyEndTime !== undefined && toneItem.yearlyStartTime !== undefined)
                   {
                       childListTonesDto.setYearlyEndTime(toneItem.yearlyEndTime);
                       childListTonesDto.setYearlyStartTime(toneItem.yearlyStartTime);

                   }
                   else{
                       childListTonesDto.setYearlyEndTime(this.context.getResources().getString(Strings.zero));
                       childListTonesDto.setYearlyStartTime(this.context.getResources().getString(Strings.zero));

                   }

                   //-----------------------------------------
                   timeType = [];
                    if (!(childListTonesDto.getCustomiseStartDate() === this.context.getResources().getString(Strings.zero)) 
                    || !(childListTonesDto.getCustomiseEndDate() === this.context.getResources().getString(Strings.zero)) )
                    {
                        
                        timeType.push(this.context.getResources().getString(Strings.NONE));                       
                       
                    } 
                   console.log("-----childListTonesDto.getWeeklyDays(): " + childListTonesDto.getWeeklyDays());
                    // if (!(childListTonesDto.getStartTimeWeekly() === this.context.getResources().getString(Strings.zero_time)) 
                    // && (!(childListTonesDto.getEndTimeWeekly() === this.context.getResources().getString(Strings.time_24))))
                    if(childListTonesDto.getWeeklyDays() !== this.context.getResources().getString(Strings.zero))
                    {
                        timeType.push(this.context.getResources().getString(Strings.WEEKLY));                       
                    } 
                 if (!(childListTonesDto.getStartDayMonthly() === this.context.getResources().getString(Strings.zero)) || !(childListTonesDto.getEndDayMonthly() === this.context.getResources().getString(Strings.zero)))
                    {
                        timeType.push(this.context.getResources().getString(Strings.MONTHLY));                       


                    } 
                 if (!(childListTonesDto.getYearlyStartMonth() === this.context.getResources().getString(Strings.zero)) || !(childListTonesDto.getYearlyEndMonth() === this.context.getResources().getString(Strings.zero))) 
                    {
                        timeType.push(this.context.getResources().getString(Strings.YEARLY));                       
                    }
                    
                    if(timeType.length === 0) {
                       
                        timeType.push(this.context.getResources().getString(Strings.full_day));
                    }
                    childListTonesDto.setTimeTypeList(timeType);
             
                    // && (childListTonesDto.getCustomiseStartDate() === this.context.getResources().getString(Strings.zero)) 
                    // || (childListTonesDto.getCustomiseEndDate() === this.context.getResources().getString(Strings.zero)) && !(childListTonesDto.getStartTimeWeekly() === this.context.getResources().getString(Strings.zero_time)) 
                    // && ((childListTonesDto.getEndTimeWeekly() === this.context.getResources().getString(Strings.time_24))) && !(childListTonesDto.getStartDayMonthly() === this.context.getResources().getString(Strings.zero)) || !(childListTonesDto.getEndDayMonthly() === this.context.getResources().getString(Strings.zero))
                    //  && (childListTonesDto.getYearlyStartMonth() === this.context.getResources().getString(Strings.zero)) || !(childListTonesDto.getYearlyEndMonth() === this.context.getResources().getString(Strings.zero))

            //end of type

                    if(toneItem.isShuffle !== undefined && toneItem.isShuffle === "T")
                    {
                        console.log("-----shuffle in listtonebuilder "+toneItem.isShuffle);

                        childListTonesDto.setIsShuffle("T");

                    }
                    else
                    {
                        childListTonesDto.setIsShuffle("F");

                    }

                    if(toneItem.isStatusRbt !== undefined && toneItem.isStatusRbt === "T")
                    {
                        childListTonesDto.setIsStatusRBT(true);
                    }
                    if(childListTonesDto.getServiceName() === this.context.getResources().getString(Strings.specialCallerSetting))
                    {
                        console.log("child &&&&&&&&",listToneApkItem.msisdnB);
                        childListTonesDto.setMsisdnB(listToneApkItem.msisdnB);
                    }

                    if(listToneApkItem.groupId !== 0)
                    {
                        // msisdnB = "091222222777|Dummy,091222222999|Dummy2,091222222888|Dummy3";
                        let memberDetailsDto : MemberDetailsDtoImpl ;
                        let listOfMemberDetails: MemberDetailsDto[] = [];

                        let listOfMsisdnAndMemberName : string[] = [];
                        listOfMsisdnAndMemberName = listToneApkItem.msisdnB.split(",");
                        listOfMsisdnAndMemberName.forEach((msisdnAndMemberNameItem: any) => {
                            memberDetailsDto = new MemberDetailsDtoImpl();
                            memberDetailsDto.setMsisdn(msisdnAndMemberNameItem.split("|")[0]);
                            memberDetailsDto.setMemberName(msisdnAndMemberNameItem.split("|")[1]);

                            listOfMemberDetails.push(memberDetailsDto);
                        });
                        
                        groupDto = new GroupDtoImpl();
                        groupDto.setMembersList(listOfMemberDetails);
                        groupDto.setServiceName(listToneApkItem.serviceName);
                        groupDto.setMsisdnB(listToneApkItem.msisdnB);
                        groupDto.setGroupId(listToneApkItem.groupId);
                        groupDto.setGroupName(listToneApkItem.groupName);
                        groupDto.setGroupDesc(listToneApkItem.groupDesc);
                        groupDto.setIsBlocked(listToneApkItem.isBlocked);
                        groupDto.setId(index);
                        childListTonesDto.setGroupDto(groupDto);
                    }
                    listOfListTones.push(childListTonesDto);
                });
            }
            else if(listToneApkItem.groupId !== 0)
            {
                // msisdnB = "091222222777|Dummy,091222222999|Dummy2,091222222888|Dummy3";
                 let memberDetailsDto : MemberDetailsDtoImpl ;
                let listOfMemberDetails: MemberDetailsDto[] = [];

                let listOfMsisdnAndMemberName : string[] = [];
                listOfMsisdnAndMemberName = listToneApkItem.msisdnB.split(",");
                listOfMsisdnAndMemberName.forEach((msisdnAndMemberNameItem: any) => {
                    memberDetailsDto = new MemberDetailsDtoImpl();
                    memberDetailsDto.setMsisdn(msisdnAndMemberNameItem.split("|")[0]);
                    memberDetailsDto.setMemberName(msisdnAndMemberNameItem.split("|")[1]);
                            
                    listOfMemberDetails.push(memberDetailsDto);
                });
                
                childListTonesDto = new ChildListTonesDtoImpl();
                groupDto = new GroupDtoImpl();
                groupDto.setMembersList(listOfMemberDetails);
                groupDto.setServiceName(listToneApkItem.serviceName);
                groupDto.setMsisdnB(listToneApkItem.msisdnB);
                groupDto.setGroupId(listToneApkItem.groupId);
                groupDto.setGroupName(listToneApkItem.groupName);
                groupDto.setGroupDesc(listToneApkItem.groupDesc);
                groupDto.setIsBlocked(listToneApkItem.isBlocked);
                groupDto.setId(index);
                childListTonesDto.setGroupDto(groupDto);
                listOfListTones.push(childListTonesDto);
            }
        });
        return listOfListTones;
    }
    private getStatus(status: string)
    {
        if(status === "P")
        {
            return ToneStatus.PENDING;
        }
        else if(status === "R")
        {
            return ToneStatus.REJECTED;
        }
        else if(status === "IA")
        {
            return ToneStatus.INACTIVE;
        }
        else
        {
            return ToneStatus.ACCEPTED;
        }
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/currentlyplayingtunes/currentlyplayinglisttonesbuilder.ts